module.exports = __webpack_public_path__ + "assets/align-top.a22bd932.svg";